import * as yup from 'yup';
import { validationsMessages } from '../../lib';

export interface ChainSelectorModalProps {
    chainSelectorModalTitle: string;
    chainSelectorModalSubheading: string;
    chainSelectorModal: boolean;
    selectChainFieldError: boolean;
    setSelectChainFieldError: React.Dispatch<React.SetStateAction<boolean>>;
    handleCloseModal: () => void;
    handleCancelButtonClick: () => void;
    handleNextButtonClick: () => void;
    setSelectedChain: Function;
    selectedChain: string;
}

export const chainSelectorModalStyles = {
    dialogStyles: {
        '& .MuiPaper-root': {
            width: '825px',
            maxWidth: 'none',
            '& .MuiDialogContent-root': {
                p: '16px 133px 113.6px 133px',
                overflow: 'hidden',
            },
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        mt: -1,
        gap: 1,
    },
};

export interface ChainSelectorInputs {
    chain: string;
}

export const ChainSelectorSchema = yup.object({
    chain: yup.string().required(validationsMessages.required),
});

export const chainSelectorDefaults = {
    chain: '',
};
